import React, { useState } from 'react'
import c from 'classnames'
import { FormFormLlmInterfaceStyleChoices } from '@/__gen/types'
import { ErrorBoundary } from '@/components/common/error-boundary'
import { useFormContext } from '@/state/main-form/reducer'
import { FormControlPanel } from './form-control-panel'
import style from './index.module.sass'

export const FormControlPanelContainer = () => {
	const formContext = useFormContext()

	const [chatOpen, setChatOpen] = useState(formContext.form.llmInterfaceStyle === FormFormLlmInterfaceStyleChoices.Hero)

	const isExternalForm = !!formContext.publicForm?.code

	return (
		<div className={c(style.rightPanelContainer, { [style.chatRightPanelContainer]: chatOpen, [style.externalForm]: isExternalForm })}>
			<ErrorBoundary>
				<FormControlPanel chatOpen={chatOpen} setChatOpen={setChatOpen} />
			</ErrorBoundary>
		</div>
	)
}
